import { DataBaseModelInterface } from '@solcre-org/core';

export class DuplicateTariffFormModel implements DataBaseModelInterface {
  constructor(public berthingType: string | null = null) {}

  fromJSON(json: any): DuplicateTariffFormModel {
    if (json) {
      this.berthingType = json.berthingType ?? null;
    }
    return this;
  }

  toJSON() {
    return { berthingType: this.berthingType };
  }

  getId() {
    return this.berthingType ?? '';
  }

  getReference() {
    return this.berthingType ?? '';
  }
}
